var lib_core          = require("lib-core");
var lib_geometry      = require("lib-geometry");

var AbstractUIModel = function () {
    lib_core.Model.apply(this);

    // this.moveVector = this.value("moveVector", new lib_geometry.Coord(0,0), false, true);
    this.position = this.value("position", true);
    this.position(new lib_geometry.Coord(0,0));
};

lib_core.inherit(AbstractUIModel, lib_core.Model);

module.exports = AbstractUIModel;

AbstractUIModel.prototype.setPosition = function(x, y){
    this.position(new lib_geometry.Coord(x,y));
};

AbstractUIModel.prototype.move = function(x, y){
    var nX = this.position().x + x;
    var nY = this.position().y + y;
    this.setPosition(nX,nY);
};
